// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*--Fonts--*/
:root {
  --primary: #FF914E;
  --secondary: #07748F;
  --info: #343833;
  --white: #FFFFFF;
  --black: #000000;
  --liteblue: #e7f3f5;
  --shadeblue: #d1e6eb;
  --hrborder: #e4dede;
  --theader: #f5f7f8;
  --thinfo: #384648;
  --thborder: #dee2e6;
  --dlink: #007bff;
  --btninfo: #313232;
  --gary: #5a6e82;
  --high-to-low: linear-gradient(to right, #07748F 0%, #72B0C0 100%);
  --low-to-high: linear-gradient(90deg, #72B0C0 0, #07748F);
  --red: #f15e48;
  --green: #02681a;
  --lowgray: #A0B2B5;
}

/* ---- font family ----*/
/*--- pixels --- */
/*---font size---*/
/*---font weight---*/
/*--- percentage ---*/
/*--- display ---*/
/*--- alignment ---*/
/*--Position --*/
/*--- Text Transform ---*/
/*-- Text Style --*/
/*-- Info and paragraph --*/
.font-common {
  font-size: 14px;
  color: var(--info);
  font-weight: 600;
}

/*--Flex-box--*/
.w-flex {
  width: 100%;
  display: flex;
}

/*-- Form Label--*/
.input-fonts, .inputfields, .formlabel {
  font-size: 11px;
  color: var(--black);
}

.formlabel {
  opacity: 1;
  margin-bottom: 0.3rem;
  margin-top: 5px;
  font-weight: 500;
}

.login-btn-hover {
  color: var(--primary);
  background-position: left;
  fill: var(--primary) !important;
}

.heading-comman, .heading-4, .heading-3, .heading-2, .card-content h4, .banner-bg-content .banner-container .banner-content .smalltext, .heading-1, .banner-bg-content .banner-container .banner-content h1 {
  font-style: normal;
  font-weight: 700;
}

.heading-1, .banner-bg-content .banner-container .banner-content h1 {
  font-size: 43px;
  line-height: 62px;
  margin-bottom: 25px;
}

.heading-2, .card-content h4, .banner-bg-content .banner-container .banner-content .smalltext {
  font-size: 35px;
  line-height: 50px;
}

.heading-3 {
  font-size: 30px;
  line-height: 60px;
  margin-bottom: 15px;
}

.heading-4 {
  font-weight: 600;
  font-size: 25px;
  line-height: 26px;
}

.inputfields {
  height: 30px;
  line-height: 30px;
  opacity: 0.8;
  padding: 0px 0.5rem;
  background: #F4F6F7;
}

/*-- Box outer --*/
.boxing {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: var(--white);
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  padding: 15px 15px;
}

.login-btn-hover {
  color: var(--primary);
  background-position: left;
  fill: var(--primary) !important;
}

.heading-comman, .heading-1, .banner-bg-content .banner-container .banner-content h1, .heading-2, .card-content h4, .banner-bg-content .banner-container .banner-content .smalltext, .heading-3, .heading-4 {
  font-style: normal;
  font-weight: 700;
}

.heading-1, .banner-bg-content .banner-container .banner-content h1 {
  font-size: 43px;
  line-height: 62px;
  margin-bottom: 25px;
}

.heading-2, .card-content h4, .banner-bg-content .banner-container .banner-content .smalltext {
  font-size: 35px;
  line-height: 50px;
}

.heading-3 {
  font-size: 30px;
  line-height: 60px;
  margin-bottom: 15px;
}

/*--Buttons common--*/
.button-common, .secondary_button, .primary_button, .banner-bg-content .banner-container .banner-btn a {
  background: transparent !important;
  display: inline-block !important;
  padding: 8px 30px !important;
  height: 44px !important;
  border-radius: 50px !important;
  position: relative !important;
  transition: all 0.5s linear !important;
  text-align: center !important;
  vertical-align: middle !important;
  text-decoration: none !important;
  outline: 0px !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  line-height: 0px !important;
  cursor: pointer !important;
  text-transform: capitalize !important;
}

.link_button, .banner-bg-content .banner-container .banner-btn a {
  padding: 8px 40px !important;
  line-height: 1.5 !important;
  height: fit-content !important;
}

.primary, .secondary_button:hover, .primary_button, .banner-bg-content .banner-container .banner-btn a {
  border: 3px solid var(--primary) !important;
  background-color: var(--primary) !important;
  color: var(--white) !important;
  box-shadow: none !important;
}

.secondary, .secondary_button, .primary_button:hover, .banner-bg-content .banner-container .banner-btn a:hover {
  border: 3px solid var(--primary) !important;
  background-color: var(--primary) !important;
  color: var(--white) !important;
  box-shadow: none !important;
}

.stepper-next-btn:hover {
  border: 0px !important;
}

.primary_button span.MuiTouchRipple-root, .banner-bg-content .banner-container .banner-btn a span.MuiTouchRipple-root {
  display: none;
}

.secondary_button span.MuiTouchRipple-root {
  display: none;
}

.seeanalytics {
  padding: 8px 18px !important;
  font-size: 13px !important;
  font-weight: 500 !important;
  height: 33px !important;
}
.seeanalytics:hover, .seeanalytics:active, .seeanalytics:focus {
  background-color: var(--primary) !important;
}

.btn-wid, .banner-bg-content .banner-container .banner-btn a {
  padding: 10px 40px !important;
  margin-top: 25px;
  margin-right: 13px;
}

/* --banner-style-- */
.banner-bg-content .banner-container {
  padding-top: 30px;
  padding-bottom: 30px;
  min-height: 585px;
}
.banner-bg-content .banner-container .banner-content {
  padding: 0px;
  color: var(--white);
  font-style: normal;
}
.banner-bg-content .banner-container .banner-content .smalltext {
  font-weight: 600 !important;
  line-height: 68px !important;
  color: #07748f !important;
  margin-bottom: 0 !important;
  margin-top: 17px !important;
}
.banner-bg-content .banner-container .banner-content p {
  font-weight: 400;
  font-size: 20px;
  line-height: 30px;
  margin-bottom: 1rem;
}
.banner-bg-content .banner-container .banner-img img {
  width: 119%;
  position: relative;
  top: -10px;
  left: 74px;
  height: auto;
}
.banner-bg-content .banner-container .banner-btn a {
  box-shadow: 0 5px 15px 1.5px rgba(255, 145, 78, 0.3);
}
.banner-bg-content .banner-container .banner-btn a:nth-child(2) {
  background-color: transparent !important;
  border: 2px solid var(--white) !important;
}
.banner-bg-content .banner-container .banner-btn a:hover {
  box-shadow: none;
}

/* -- card-style -- */
.card-content {
  background-color: rgba(7, 116, 143, 0.05);
}
.card-content h4 {
  margin-bottom: 40px;
}
.card-content .section-card {
  width: 100%;
  margin-left: auto;
  display: block;
  height: 105px;
  background: var(--white);
  box-shadow: 0 4px 20px rgba(23, 125, 150, 0.2);
  border-radius: 20px;
  padding: 10px 18px 10px 6px;
  margin-bottom: 25px;
  transition: all 0.5s ease-in-out;
  flex-direction: unset !important;
}
.card-content .section-card p {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  margin-bottom: 0;
  margin-left: 10px;
}
.card-content .section-card:hover {
  transform: scale(1.05);
  box-shadow: 0 5px 15px 1.5px rgba(255, 145, 78, 0.3) !important;
}

.btn-wid, .banner-bg-content .banner-container .banner-btn a {
  padding: 10px 40px !important;
  margin-top: 25px;
  margin-right: 13px;
}

/* --banner-style-- */
.banner-bg-content .banner-container {
  padding-top: 30px;
  padding-bottom: 30px;
  min-height: 585px;
}
.banner-bg-content .banner-container .banner-content {
  padding: 0px;
  color: var(--white);
  font-style: normal;
}
.banner-bg-content .banner-container .banner-content .smalltext {
  font-weight: 600 !important;
  line-height: 68px !important;
  color: #07748f !important;
  margin-bottom: 0 !important;
  margin-top: 17px !important;
}
.banner-bg-content .banner-container .banner-content p {
  font-weight: 400;
  font-size: 20px;
  line-height: 30px;
  margin-bottom: 1rem;
}
.banner-bg-content .banner-container .banner-img img {
  width: 119%;
  position: relative;
  top: -10px;
  left: 74px;
  height: auto;
}
.banner-bg-content .banner-container .banner-btn a {
  box-shadow: 0 5px 15px 1.5px rgba(255, 145, 78, 0.3);
}
.banner-bg-content .banner-container .banner-btn a:nth-child(2) {
  background-color: transparent !important;
  border: 2px solid var(--white) !important;
}
.banner-bg-content .banner-container .banner-btn a:hover {
  box-shadow: none;
}

/* -- card-style -- */
.card-comman {
  background: #fff;
  box-shadow: 0 4px 40px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
}

.card-content {
  background-color: rgba(7, 116, 143, 0.05);
}
.card-content h4 {
  margin-bottom: 40px;
}
.card-content .section-card {
  width: 100%;
  margin-left: auto;
  display: block;
  height: 105px;
  background: var(--white);
  box-shadow: 0 4px 20px rgba(23, 125, 150, 0.2);
  border-radius: 20px;
  padding: 10px 18px 10px 6px;
  margin-bottom: 25px;
  transition: all 0.5s ease-in-out;
  flex-direction: unset !important;
}
.card-content .section-card .h-op-features {
  font-weight: 600 !important;
  margin-bottom: 5px !important;
}
.card-content .section-card p {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  margin-bottom: 0;
  margin-left: 10px;
}
.card-content .section-card:hover {
  transform: scale(1.05);
  box-shadow: 0 5px 15px 1.5px rgba(255, 145, 78, 0.3) !important;
}

.container-notfound {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 80vh;
}
.container-notfound .image-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.container-notfound .image-container img {
  width: 100%;
}
.container-notfound .page-content {
  font-size: 1rem;
  font-weight: 500;
}
.container-notfound .goto-btn {
  margin-top: 20px;
  background-color: var(--primary);
  color: #fff;
  font-size: 16px;
  padding: 5px 15px;
  border-radius: 20px;
  border: 0;
  outline: none;
}

.blinking-red {
  color: red;
  animation: blink 1s infinite;
}

@keyframes blink {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/style.scss","webpack://./src/pages/static/accessdenied/accessdenied.scss"],"names":[],"mappings":"AAAA,YAAA;AAIA;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,kEAAA;EACA,yDAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;ACAF;;ADGA,yBAAA;AAIA,kBAAA;AAsFA,kBAAA;AAqCA,oBAAA;AASA,qBAAA;AAmBA,kBAAA;AAYA,oBAAA;AAaA,gBAAA;AAKA,yBAAA;AAMA,mBAAA;AAGA,2BAAA;AACA;EACE,eAhLM;EAiLN,kBAAA;EACA,gBAnEM;ACrHR;;AD2LA,eAAA;AACA;EACE,WAnDQ;EAoDR,aAhDK;ACxIP;;AD2LA,kBAAA;AACA;EACE,eAjMM;EAkMN,mBAAA;ACxLF;;AD2LA;EAEE,UAAA;EACA,qBAAA;EACA,eA/MK;EAgNL,gBAxFM;ACjGR;;AD4LA;EACE,qBAAA;EACA,yBAtDK;EAuDL,+BAAA;ACzLF;;AD4LA;EACE,kBApCO;EAqCP,gBAAA;ACzLF;;AD4LA;EACE,eAxLM;EAyLN,iBAtKM;EAuKN,mBA5MM;ACmBR;;AD6LA;EACE,eAvMM;EAwMN,iBAzLM;ACDR;;AD8LA;EACE,eAlNM;EAmNN,iBArLM;EAsLN,mBAnOM;ACwCR;;AD+LA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;AC5LF;;ADgMA;EAEE,YAjOM;EAkON,iBAlOM;EAmON,YAAA;EACA,mBAAA;EACA,mBAAA;AC9LF;;ADiMA,kBAAA;AACA;EACE,kBAzFS;EA0FT,aAnHK;EAoHL,sBAjGO;EAkGP,YAAA;EACA,qBAlGU;EAmGV,8BAAA;EACA,2BAnGU;EAoGV,sCAAA;EACA,sBAAA;EACA,mDAAA;EACA,kBAAA;AC9LF;;ADiMA;EACE,qBAAA;EACA,yBApHK;EAqHL,+BAAA;AC9LF;;ADiMA;EACE,kBAlGO;EAmGP,gBAAA;AC9LF;;ADiMA;EACE,eAtPM;EAuPN,iBApOM;EAqON,mBA1QM;AC4ER;;ADkMA;EACE,eArQM;EAsQN,iBAvPM;ACwDR;;ADmMA;EACE,eAhRM;EAiRN,iBAnPM;EAoPN,mBAjSM;ACiGR;;ADoMA,qBAAA;AACA;EACE,kCAAA;EACA,gCAAA;EACA,4BAAA;EACA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,sCAAA;EACA,6BAAA;EACA,iCAAA;EACA,gCAAA;EACA,uBAAA;EACA,0BAAA;EACA,2BAAA;EACA,2BAAA;EACA,0BAAA;EACA,qCAAA;ACjMF;;ADoMA;EACE,4BAAA;EACA,2BAAA;EACA,8BAAA;ACjMF;;ADoMA;EACE,2CAAA;EACA,2CAAA;EACA,8BAAA;EACA,2BAAA;ACjMF;;ADoMA;EACE,2CAAA;EACA,2CAAA;EACA,8BAAA;EACA,2BAAA;ACjMF;;ADmMA;EACE,sBAAA;AChMF;;AD2ME;EACE,aAAA;ACxMJ;;ADoNE;EACE,aAAA;ACjNJ;;ADoNA;EACE,4BAAA;EACA,0BAAA;EACA,2BAAA;EACA,uBAAA;ACjNF;ADkNE;EACE,2CAAA;AChNJ;;ADoNA;EACE,6BAAA;EACA,gBAAA;EACA,kBAAA;ACjNF;;ADoNA,qBAAA;AAEE;EACE,iBA7WI;EA8WJ,oBA9WI;EA+WJ,iBAAA;AClNJ;ADoNI;EACE,YAjZC;EAkZD,mBAAA;EACA,kBAxNG;ACMT;ADoNM;EACE,2BAAA;EACA,4BAAA;EACA,yBAAA;EACA,2BAAA;EACA,2BAAA;AClNR;AD0NM;EACE,gBAvSA;EAwSA,eA/YA;EAgZA,iBAtYA;EAuYA,mBAAA;ACxNR;AD6NM;EACE,WAAA;EACA,kBA7PG;EA8PH,UAAA;EACA,UAAA;EACA,YAtRD;AC2DP;ADgOM;EAEE,oDAAA;AC/NR;ADiOQ;EACE,wCAAA;EACA,yCAAA;AC/NV;ADqOQ;EACE,gBArSH;ACkEP;;AD0OA,qBAAA;AACA;EACE,yCAAA;ACvOF;ADyOE;EACE,mBAraI;AC8LR;AD2OE;EACE,WAhUM;EAiUN,iBA1TG;EA2TH,cA7TI;EA8TJ,aAAA;EACA,wBAAA;EACA,8CAAA;EACA,mBApcI;EAqcJ,2BAAA;EACA,mBAjcI;EAkcJ,gCAAA;EACA,gCAAA;ACzOJ;AD2OI;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;ACzON;AD4OI;EACE,sBAAA;EACA,+DAAA;AC1ON;;AD+OE;EACE,6BAAA;EACA,gBAAA;EACA,kBAAA;AC5OJ;;AD+OE,qBAAA;AAEE;EACE,iBAzdE;EA0dF,oBA1dE;EA2dF,iBAAA;AC7ON;AD+OM;EACE,YA7fD;EA8fC,mBAAA;EACA,kBApUC;ACuFT;AD+OQ;EACE,2BAAA;EACA,4BAAA;EACA,yBAAA;EACA,2BAAA;EACA,2BAAA;AC7OV;ADqPQ;EACE,gBAnZF;EAoZE,eA3fF;EA4fE,iBAlfF;EAmfE,mBAAA;ACnPV;ADwPQ;EACE,WAAA;EACA,kBAzWC;EA0WD,UAAA;EACA,UAAA;EACA,YAlYH;AC4IP;AD2PQ;EAEE,oDAAA;AC1PV;AD4PU;EACE,wCAAA;EACA,yCAAA;AC1PZ;ADgQU;EACE,gBAjZL;ACmJP;;ADqQE,qBAAA;AACA;EACE,gBAAA;EACA,yCAAA;EACA,mBAAA;AClQJ;;ADqQE;EACE,yCAAA;AClQJ;ADoQI;EACE,mBAvhBE;ACqRR;ADsQI;EACE,WAlbI;EAmbJ,iBA5aC;EA6aD,cA/aE;EAgbF,aAAA;EACA,wBAAA;EACA,8CAAA;EACA,mBAtjBE;EAujBF,2BAAA;EACA,mBAnjBE;EAojBF,gCAAA;EACA,gCAAA;ACpQN;ADsQM;EACE,2BAAA;EACA,6BAAA;ACpQR;ADuQM;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;ACrQR;ADwQM;EACE,sBAAA;EACA,+DAAA;ACtQR;;AAzXA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;AA4XJ;AA3XI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;AA6XR;AA5XQ;EACI,WAAA;AA8XZ;AA3XI;EACI,eAAA;EACA,gBAAA;AA6XR;AA3XI;EACI,gBAAA;EACA,gCAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;AA6XR;;AAvXA;EACI,UAAA;EACA,4BAAA;AA0XJ;;AAvXE;EACE;IAAW,UAAA;EA2Xb;EA1XE;IAAM,UAAA;EA6XR;AACF","sourcesContent":["/*--Fonts--*/\n@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap');\n\n:root {\n  --primary: #FF914E;\n  --secondary: #07748F;\n  --info: #343833;\n  --white: #FFFFFF;\n  --black: #000000;\n  --liteblue: #e7f3f5;\n  --shadeblue: #d1e6eb;\n  --hrborder: #e4dede;\n  --theader: #f5f7f8;\n  --thinfo: #384648;\n  --thborder: #dee2e6;\n  --dlink: #007bff;\n  --btninfo: #313232;\n  --gary: #5a6e82;\n  --high-to-low: linear-gradient(to right, #07748F 0%, #72B0C0 100%);\n  --low-to-high: linear-gradient(90deg, #72B0C0 0, #07748F);\n  --red: #f15e48;\n  --green: #02681a;\n  --lowgray: #A0B2B5;\n}\n\n/* ---- font family ----*/\n$montserrat : 'Montserrat';\n$roboto: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n\n/*--- pixels --- */\n$px-0: 0px;\n$px-1: 1px;\n$px-2: 2px;\n$px-3: 3px;\n$px-4: 4px;\n$px-5: 5px;\n$px-6: 6px;\n$px-7: 7px;\n$px-8: 8px;\n$px-9: 9px;\n$px-10: 10px;\n$px-11: 11px;\n$px--11: -11px;\n$px-12: 12px;\n$px-13: 13px;\n$px-14: 14px;\n$px-15: 15px;\n$px-16: 16px;\n$px-17: 17px;\n$px-18: 18px;\n$px-19: 19px;\n$px-20: 20px;\n$px-21: 21px;\n$px-22: 22px;\n$px-23: 23px;\n$px-24: 24px;\n$px-25: 25px;\n$px-26: 26px;\n$px-27: 27px;\n$px-28: 28px;\n$px-29: 29px;\n$px-30: 30px;\n$px-31: 31px;\n$px-32: 32px;\n$px-33: 33px;\n$px-34: 34px;\n$px-35: 35px;\n$px-36: 36px;\n$px-37: 37px;\n$px-38: 38px;\n$px-39: 39px;\n$px-40: 40px;\n$px-41: 41px;\n$px-42: 42px;\n$px-43: 43px;\n$px-44: 44px;\n$px-45: 45px;\n$px-46: 46px;\n$px-47: 47px;\n$px-48: 48px;\n$px-49: 49px;\n$px-50: 50px;\n$px-51: 51px;\n$px-52: 52px;\n$px-53: 53px;\n$px-54: 54px;\n$px-55: 55px;\n$px-56: 56px;\n$px-57: 57px;\n$px-58: 58px;\n$px-59: 59px;\n$px-60: 60px;\n$px-61: 61px;\n$px-62: 62px;\n$px-63: 63px;\n$px-64: 64px;\n$px-65: 65px;\n$px-70: 70px;\n$px-74: 74px;\n$px-75: 75px;\n$px-80: 80px;\n$px-85: 85px;\n$px-100: 100px;\n$px-115: 115px;\n$px-120: 120px;\n$px-124: 124px;\n$px-130: 130px;\n$px-150: 150px;\n$px-200: 200px;\n$px-226: 226px;\n$px-250: 250px;\n$px-280: 280px;\n$px-300: 300px;\n$px-585: 585px;\n\n/*---font size---*/\n$f-10: $px-10;\n$f-11: $px-11;\n$f-12: $px-12;\n$f-13: $px-13;\n$f-14: $px-14;\n$f-15: $px-15;\n$f-16: $px-16;\n$f-17: $px-17;\n$f-18: $px-18;\n$f-19: $px-19;\n$f-20: $px-20;\n$f-21: $px-21;\n$f-22: $px-22;\n$f-23: $px-23;\n$f-24: $px-24;\n$f-25: $px-25;\n$f-26: $px-26;\n$f-27: $px-27;\n$f-28: $px-28;\n$f-29: $px-29;\n$f-30: $px-30;\n$f-31: $px-31;\n$f-32: $px-32;\n$f-33: $px-33;\n$f-34: $px-34;\n$f-35: $px-35;\n$f-36: $px-36;\n$f-37: $px-37;\n$f-38: $px-38;\n$f-39: $px-39;\n$f-40: $px-40;\n$f-41: $px-41;\n$f-42: $px-42;\n$f-43: $px-43;\n$f-46: $px-46;\n\n/*---font weight---*/\n$f-300: 300;\n$f-400: 400;\n$f-500: 500;\n$f-600: 600;\n$f-700: 700;\n$f-800: 800;\n$f-900: 900;\n\n/*--- percentage ---*/\n$per-8: 8%;\n$per-10: 10%;\n$per-18: 18%;\n$per-30: 30%;\n$per-35: 35%;\n$per-38: 38%;\n$per-40: 40%;\n$per-45: 45%;\n$per-48: 48%;\n$per-50: 50%;\n$per-55: 55%;\n$per-60: 60%;\n$per-85: 85%;\n$per-90: 90%;\n$per-91: 91%;\n$per-100: 100%;\n$per-200: 200%;\n\n/*--- display ---*/\n$flex: flex;\n$block: block;\n$grid: grid;\n$auto: auto;\n$inlineblock: inline-block;\n$row: row;\n$none: none;\n$max-content: max-content;\n$transparent: transparent;\n$no-repeat: no-repeat;\n\n/*--- alignment ---*/\n$top: top;\n$left: left;\n$center: center;\n$right: right;\n$bottom: bottom;\n$middle: middle;\n$space-between: space-between;\n$column: column;\n$breakword: break-word;\n$borderbox: border-box;\n$end: end;\n\n/*--Position --*/\n$relative: relative;\n$absolute: absolute;\n$initial: initial;\n\n/*--- Text Transform ---*/\n$uppercase: uppercase;\n$lowercase: lowercase;\n$capitalize: capitalize;\n$underline: underline;\n\n/*-- Text Style --*/\n$normal: normal;\n\n/*-- Info and paragraph --*/\n.font-common {\n  font-size: $f-14;\n  color: var(--info);\n  font-weight: $f-600;\n}\n\n/*--Flex-box--*/\n.w-flex {\n  width: $per-100;\n  display: $flex;\n}\n\n/*-- Form Label--*/\n.input-fonts {\n  font-size: $f-11;\n  color: var(--black);\n}\n\n.formlabel {\n  @extend .input-fonts;\n  opacity: 1;\n  margin-bottom: 0.3rem;\n  margin-top: $px-5;\n  font-weight: $f-500;\n}\n\n.login-btn-hover {\n  color: var(--primary);\n  background-position: $left;\n  fill: var(--primary) !important;\n}\n\n.heading-comman {\n  font-style: $normal;\n  font-weight: 700;\n}\n\n.heading-1 {\n  font-size: $f-43;\n  line-height: $px-62;\n  margin-bottom: $px-25;\n  @extend .heading-comman;\n}\n\n.heading-2 {\n  font-size: $f-35;\n  line-height: $px-50;\n  @extend .heading-comman;\n}\n\n.heading-3 {\n  font-size: $f-30;\n  line-height: $px-60;\n  margin-bottom: $px-15;\n  @extend .heading-comman;\n}\n\n.heading-4 {\n  font-weight: 600;\n  font-size: 25px;\n  line-height: 26px;\n  @extend .heading-comman;\n}\n\n.inputfields {\n  @extend .input-fonts;\n  height: $px-30;\n  line-height: $px-30;\n  opacity: .8;\n  padding: $px-0 0.5rem;\n  background: #F4F6F7;\n}\n\n/*-- Box outer --*/\n.boxing {\n  position: $relative;\n  display: $flex;\n  flex-direction: $column;\n  min-width: 0;\n  word-wrap: $breakword;\n  background-color: var(--white);\n  background-clip: $borderbox;\n  border: $px-1 solid rgba(0, 0, 0, .125);\n  border-radius: 0.25rem;\n  box-shadow: 0 .125rem .25rem rgba(0, 0, 0, .075);\n  padding: $px-15 $px-15;\n}\n\n.login-btn-hover {\n  color: var(--primary);\n  background-position: $left;\n  fill: var(--primary) !important;\n}\n\n.heading-comman {\n  font-style: $normal;\n  font-weight: 700;\n}\n\n.heading-1 {\n  font-size: $f-43;\n  line-height: $px-62;\n  margin-bottom: $px-25;\n  @extend .heading-comman;\n}\n\n.heading-2 {\n  font-size: $f-35;\n  line-height: $px-50;\n  @extend .heading-comman;\n}\n\n.heading-3 {\n  font-size: $f-30;\n  line-height: $px-60;\n  margin-bottom: $px-15;\n  @extend .heading-comman;\n}\n\n/*--Buttons common--*/\n.button-common {\n  background: $transparent  !important;\n  display: $inlineblock  !important;\n  padding: $px-8 $px-30  !important;\n  height: $px-44  !important;\n  border-radius: $px-50  !important;\n  position: $relative  !important;\n  transition: all .5s linear !important;\n  text-align: $center  !important;\n  vertical-align: $middle  !important;\n  text-decoration: $none  !important;\n  outline: $px-0  !important;\n  font-size: $f-16  !important;\n  font-weight: $f-600  !important;\n  line-height: $px-0  !important;\n  cursor: pointer !important;\n  text-transform: $capitalize  !important;\n}\n\n.link_button {\n  padding: $px-8 $px-40  !important;\n  line-height: 1.5 !important;\n  height: fit-content !important;\n}\n\n.primary {\n  border: $px-3 solid var(--primary) !important;\n  background-color: var(--primary) !important;\n  color: var(--white) !important;\n  box-shadow: none!important;\n}\n\n.secondary {\n  border: $px-3 solid var(--primary) !important;\n  background-color: var(--primary) !important;\n  color: var(--white) !important;\n  box-shadow: none!important;\n}\n.stepper-next-btn:hover {\n  border: 0px !important;\n}\n\n.primary_button {\n  @extend .button-common;\n  @extend .primary;\n\n  &:hover {\n    @extend .secondary;\n  }\n\n  span.MuiTouchRipple-root {\n    display: none;\n  }\n}\n\n.secondary_button {\n  @extend .button-common;\n  @extend .secondary;\n\n  &:hover {\n    @extend .primary;\n  }\n\n  span.MuiTouchRipple-root {\n    display: none;\n  }\n}\n.seeanalytics {\n  padding: 8px 18px!important;\n  font-size: 13px!important;\n  font-weight: 500!important;\n  height: 33px!important;\n  &:hover, &:active, &:focus {\n    background-color: var(--primary)!important;\n  }\n}\n\n.btn-wid {\n  padding: 10px 40px !important;\n  margin-top: 25px;\n  margin-right: 13px;\n}\n\n/* --banner-style-- */\n.banner-bg-content {\n  .banner-container {\n    padding-top: $px-30;\n    padding-bottom: $px-30;\n    min-height: 585px;\n\n    .banner-content {\n      padding: $px-0;\n      color: var(--white);\n      font-style: $normal;\n\n      .smalltext {\n        font-weight: 600 !important;\n        line-height: 68px !important;\n        color: #07748f !important;\n        margin-bottom: 0 !important;\n        margin-top: 17px !important;\n        @extend .heading-2;\n      }\n\n      h1 {\n        @extend .heading-1;\n      }\n\n      p {\n        font-weight: $f-400;\n        font-size: $f-20;\n        line-height: $px-30;\n        margin-bottom: 1rem;\n      }\n    }\n\n    .banner-img {\n      img {\n        width: 119%;\n        position: $relative;\n        top: -$px-10;\n        left: 74px;\n        height: $auto;\n      }\n    }\n\n    .banner-btn {\n      a {\n        @extend .link_button;\n        box-shadow: 0 5px 15px 1.5px rgba(255, 145, 78, .3);\n\n        &:nth-child(2) {\n          background-color: $transparent  !important;\n          border: 2px solid var(--white) !important;\n        }\n\n        @extend .btn-wid;\n        @extend .primary_button;\n\n        &:hover {\n          box-shadow: $none;\n        }\n      }\n    }\n  }\n}\n\n/* -- card-style -- */\n.card-content {\n  background-color: rgba(7, 116, 143, .05);\n\n  h4 {\n    margin-bottom: $px-40;\n    @extend .heading-2;\n  }\n\n  .section-card {\n    width: $per-100;\n    margin-left: $auto;\n    display: $block;\n    height: 105px;\n    background: var(--white);\n    box-shadow: 0 4px 20px rgba(23, 125, 150, .2);\n    border-radius: $px-20;\n    padding: 10px 18px 10px 6px;\n    margin-bottom: $px-25;\n    transition: all .5s ease-in-out;\n    flex-direction: unset !important;\n\n    p {\n      font-style: normal;\n      font-weight: 400;\n      font-size: 14px;\n      line-height: 22px;\n      margin-bottom: 0;\n      margin-left: 10px;\n    }\n\n    &:hover {\n      transform: scale(1.05);\n      box-shadow: 0 5px 15px 1.5px rgba(255, 145, 78, .3) !important;\n    }\n  }\n}\n\n  .btn-wid {\n    padding: 10px 40px !important;\n    margin-top: 25px;\n    margin-right: 13px;\n  }\n\n  /* --banner-style-- */\n  .banner-bg-content {\n    .banner-container {\n      padding-top: $px-30;\n      padding-bottom: $px-30;\n      min-height: 585px;\n\n      .banner-content {\n        padding: $px-0;\n        color: var(--white);\n        font-style: $normal;\n\n        .smalltext {\n          font-weight: 600 !important;\n          line-height: 68px !important;\n          color: #07748f !important;\n          margin-bottom: 0 !important;\n          margin-top: 17px !important;\n          @extend .heading-2;\n        }\n\n        h1 {\n          @extend .heading-1;\n        }\n\n        p {\n          font-weight: $f-400;\n          font-size: $f-20;\n          line-height: $px-30;\n          margin-bottom: 1rem;\n        }\n      }\n\n      .banner-img {\n        img {\n          width: 119%;\n          position: $relative;\n          top: -$px-10;\n          left: 74px;\n          height: $auto;\n        }\n      }\n\n      .banner-btn {\n        a {\n          @extend .link_button;\n          box-shadow: 0 5px 15px 1.5px rgba(255, 145, 78, .3);\n\n          &:nth-child(2) {\n            background-color: $transparent  !important;\n            border: 2px solid var(--white) !important;\n          }\n\n          @extend .btn-wid;\n          @extend .primary_button;\n\n          &:hover {\n            box-shadow: $none;\n          }\n        }\n      }\n    }\n  }\n\n  /* -- card-style -- */\n  .card-comman {\n    background: #fff;\n    box-shadow: 0 4px 40px rgba(0, 0, 0, .1);\n    border-radius: 20px;\n  }\n\n  .card-content {\n    background-color: rgba(7, 116, 143, .05);\n\n    h4 {\n      margin-bottom: $px-40;\n      @extend .heading-2;\n    }\n\n    .section-card {\n      width: $per-100;\n      margin-left: $auto;\n      display: $block;\n      height: 105px;\n      background: var(--white);\n      box-shadow: 0 4px 20px rgba(23, 125, 150, .2);\n      border-radius: $px-20;\n      padding: 10px 18px 10px 6px;\n      margin-bottom: $px-25;\n      transition: all .5s ease-in-out;\n      flex-direction: unset !important;\n\n      .h-op-features {\n        font-weight: 600 !important;\n        margin-bottom: 5px !important;\n      }\n\n      p {\n        font-style: normal;\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 22px;\n        margin-bottom: 0;\n        margin-left: 10px;\n      }\n\n      &:hover {\n        transform: scale(1.05);\n        box-shadow: 0 5px 15px 1.5px rgba(255, 145, 78, .3) !important;\n      }\n    }\n  }","@use \"../../../style.scss\" as *;\n.container-notfound {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    height: 80vh;\n    .image-container {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        width: 100%;\n        height: 100%;\n        img {\n            width: 100% ;\n        }\n    }\n    .page-content {\n        font-size: 1rem;\n        font-weight: 500;\n    }\n    .goto-btn {\n        margin-top: 20px;\n        background-color: var(--primary);\n        color: #fff;\n        font-size: 16px;\n        padding: 5px 15px;\n        border-radius: 20px;\n        border: 0;\n        outline: none;\n    }\n}\n@media screen {\n    \n}\n.blinking-red {\n    color: red;\n    animation: blink 1s infinite;\n  }\n  \n  @keyframes blink {\n    0%, 100% { opacity: 1; }\n    50% { opacity: 0; }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
